<!DOCTYPE html>
<!-- Start "No thanks" confirmation popup via Store Checkout  -->
<div class="modal-container">
  <div class="modal-wrapper">
    <h2 class="modal-title"> {{ "no-thanks-confirmation-popup.title" | translate }} </h2>
    <p class="sub-heading"> {{ "no-thanks-confirmation-popup.missed" | translate }} </p>
    <p class="amount">
      @if (isDiscountLottery) {
      {{ lottery?.jackpot_value | formatJackpot }}
      } @else if (!isDiscountLottery && jackpotValue) {
         {{ jackpotValue }}
      } @else if (!isDiscountLottery && !jackpotValue) {
      {{ currencySymbol || '€' }}{{ lottery?.int_jackpot_value?.[preferredCurrency] | formatJackpot }}
      }
    </p>

    <p class="sub-heading"> {{ "no-thanks-confirmation-popup.want" | translate }} </p>
    <button type="button" class="btn btn-light" (click)="close()"> {{ "no-thanks-confirmation-popup.back" |
      translate }} </button>
    <p class="skip" (click)="backToPreviousPage()"> {{ "no-thanks-confirmation-popup.skip" | translate }} </p>
  </div>
</div>
<!-- End "No thanks" confirmation popup via Store Checkout  -->
